import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface DashboardSummary {
  total_clients: number;
  caducados: number;
  en_gracia: number;
  al_dia: number;
  total_adeudado: number;
  recent_payments: number;
  by_estado: { al_dia: number; en_gracia: number; caducado: number };
}

export function useDashboardSummary() {
  return useQuery({
    queryKey: ['dashboard', 'summary'],
    queryFn: () => api<DashboardSummary>('/dashboard/summary'),
  });
}

export function useDashboardTrend() {
  return useQuery({
    queryKey: ['dashboard', 'trend'],
    queryFn: () => api<Array<{ month: string; count: number }>>('/dashboard/payments-trend'),
  });
}
